export const DEVICE_OIL_HISTORY_SET_DATA = 'DEVICE_OIL_HISTORY_SET_DATA'
export const DEVICE_OIL_HISTORY_SET_DATA_GRAPH = 'DEVICE_OIL_HISTORY_SET_DATA_GRAPH'
export const DEVICE_OIL_HISTORY_SET_TIME_RANGE = 'DEVICE_OIL_HISTORY_SET_TIME_RANGE'

export interface DeviceOilHistoryState {
    dataGraph: unknown[]
    data: unknown[]
    from: string | number | null
    to: string | number | null
}

interface SetDataAction {
    type: typeof DEVICE_OIL_HISTORY_SET_DATA
    data: unknown[]
}

interface SetDataGraphAction {
    type: typeof DEVICE_OIL_HISTORY_SET_DATA_GRAPH
    data: unknown[]
}

interface SetTimeRangeAction {
    type: typeof DEVICE_OIL_HISTORY_SET_TIME_RANGE
    from: string | number | null
    to: string | number | null
}

type DeviceOilHistoryAction = SetDataAction | SetDataGraphAction | SetTimeRangeAction

/**
 * Set data into store
 */
function setData(state: DeviceOilHistoryState, data: unknown[]): DeviceOilHistoryState {
    return {
        ...state,
        data: data,
    }
}

/**
 * Set data graph into store
 */
function setDataGraph(state: DeviceOilHistoryState, data: unknown[]): DeviceOilHistoryState {
    return {
        ...state,
        dataGraph: data,
    }
}

/**
 * Set timestamp to filter
 */
function setTimeRange(
    state: DeviceOilHistoryState,
    from: string | number | null,
    to: string | number | null,
): DeviceOilHistoryState {
    return {
        ...state,
        from: from,
        to: to,
    }
}

/**
 * Reducer for device oil history in store
 */
export default function reducer(
    state: DeviceOilHistoryState = [] as unknown as DeviceOilHistoryState,
    action: DeviceOilHistoryAction,
): DeviceOilHistoryState {
    switch (action.type) {
        case DEVICE_OIL_HISTORY_SET_DATA: return setData(state, action.data)
        case DEVICE_OIL_HISTORY_SET_DATA_GRAPH: return setDataGraph(state, action.data)
        case DEVICE_OIL_HISTORY_SET_TIME_RANGE: return setTimeRange(state, action.from, action.to)
        default: return state
    }
}
